import { render } from "./EmptyPersonalObjective.vue?vue&type=template&id=068e2b26&scoped=true"
import script from "./EmptyPersonalObjective.vue?vue&type=script&lang=js"
export * from "./EmptyPersonalObjective.vue?vue&type=script&lang=js"

import "./EmptyPersonalObjective.vue?vue&type=style&index=0&id=068e2b26&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068e2b26"]])

export default __exports__